import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import { EditorContext } from './editorContext';
import { useAutocompleteAriaHostState } from './hooks';
import { HostContext } from './hostContext';

const AutocompleteAriaHost: FC<PropsWithChildren> = ({ children }) => {
  const { hostContextValue, editorContextValue } = useAutocompleteAriaHostState();

  return (
    <HostContext.Provider value={hostContextValue}>
      <EditorContext.Provider value={editorContextValue}>{children}</EditorContext.Provider>
    </HostContext.Provider>
  );
};

export default AutocompleteAriaHost;
